import '@/styles/global.css';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@/app/providers/ThemeProvider';
import { ScrollToTop } from '@/shared/components/ScrollToTop';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import { AppRoutes } from './routes';

function App() {
  return (
    <ThemeProvider>
      <ErrorBoundary>
        <BrowserRouter>
          <ScrollToTop />
          <AppRoutes />
        </BrowserRouter>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;
